import { LiliError } from '@lili/lili-frontend-common';
import type { FieldError as RHFFieldError } from 'react-hook-form';

interface FieldErrorProps {
  error?: RHFFieldError;
  testId?: string;
}

/**
 * Renders an inline validation error for controls that don't surface one
 * themselves (radio lists, custom groups). Used across the EDD/CDD forms.
 */
export const FieldError = ({ error, testId }: FieldErrorProps) =>
  error?.message ? <LiliError errorMessage={error.message} data-testid={testId} /> : null;
